import React, { Component, Fragment } from "react";
import { connect } from 'react-redux'
import { currentWidget, setCallKeyclick, setRegPage, setShowCustomPopup } from '../../action/action'
import { setGoHome, setShowRoomDoor } from '../../layout2.0/action/homeAction'
import { HashRouter, Link, Redirect } from 'react-router-dom';
import { setShowDoorKeyPopup } from '../../layout2.0/action/action';
import {
    setDoorKeyNotificaionPage, popupOpenClose,
    setDeviceLoginPage, setDoorKeyValidationPopUp,
    SetCallNativeMethods, setQRScannerPage
} from '../../action/action'
import { withTranslation } from "react-i18next";
import $ from 'jquery'
import { calculateTimeDifference, getDefaultAnalyticsLabel } from "../../layout2.0/JS/utility";
import { sendAnalytics, getServerTime } from "../../action/homeAction"
import { CMSPath, DEMO } from "../../config/constant";
import { clearDoorKey } from "../../JS/wipeGuestData";

class DoorKeySlider extends Component {

    constructor(props) {
        super(props);
        this.state = {
            room: localStorage.getItem('room'),
            doorKeyOpened: null,
            showOverlay: false        }
    }

    componentWillUnmount() {
        localStorage.setItem("door_key_opened", true)

        if ($("#slider-unlock")[0]) {
            $("#slider-unlock")[0].removeEventListener("touchmove", () => { console.log("slider unlock touchmove removed") });
            $("#slider-unlock")[0].removeEventListener("touchend", () => { console.log("slider unlock touchend removed") });
        }

        if (window.FirebasePlugin) {
            window.FirebasePlugin.setCrashlyticsCustomKey('door_key_opened', true);
        }
    }

    componentDidMount() {
        this.props.currentWidget({ widgetType: true });
        localStorage.setItem("doorKeyPage", "DOOR KEY REQUEST")
        // this.requestLocationPermission();
        console.log('Room Door mounted')
        this.setState({ doorKeyOpened: localStorage.getItem('door_key_opened') })
        this.props.setupSliderEventHandler();

        // Removed after discussing with Majeed seems duplicate with the success event
        // if(!this.props.keyAlreadyRecieved){
        //     this.props.getServerTime((status, serverTime) => {
        //         // Send Analytics
        //         let widgetCloseTime = new Date
        //         let duration = calculateTimeDifference(this.props.widgetLaunchTime, widgetCloseTime, 'second');

        //         let label = getDefaultAnalyticsLabel({appVersion: this.props.installedAppVersion ? `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})` : ""})
        //         this.props.sendAnalytics(
        //             this.props.guestDetail, 
        //             this.props.widgetName, 
        //             'RECEIVED', 
        //             {...label, "serverTimeStamp": serverTime, "layoutTab": this.props.currentHomePage.tabName, "element": "widget", }, 
        //             duration, 
        //             this.props.guestIsLoggedIn
        //         );
        //         //
        //     } );
        // }
    }

    close = () => {
        this.props.setGoHome(true)
        this.props.setDoorKeyNotificaionPage(false);
        this.props.setDoorKeyValidationPopUp(false);
        this.props.setQRScannerPage(false);
        this.setState({ showOverlay: false })
    }

renewDoorKey = () => {        
          this.props.setShowCustomPopup(true, {
              htmlTagId: "renewDoorKey",
              heading: this.props.t('door_key.renew_door_key_process.heading'),
              subHeading: this.props.t('door_key.renew_door_key_process.subHeading'),
              primaryButtonText: this.props.t('door_key.renew_door_key_process.primaryButtonText'),
              secondaryButtonText: this.props.t('door_key.renew_door_key_process.secondaryButtonText'),
              primaryOnClick: ()=>{ this.processDoorKeyRenewal()},
              secondaryOnClick:()=>{this.props.setShowCustomPopup(false,{})},
              closeOnClick:()=>{this.props.setShowCustomPopup(false,{})},
          })
    }

    processDoorKeyRenewal = async()=>{
        this.props.setShowCustomPopup(false,{})
        await clearDoorKey();
        this.props.resetParentState()
    }

    render() {
        const { t } = this.props
        return (
            <div className="main-container" style={{ minHeight: "100vh" }}>
                <header className="inner-pages subpages no-background"
                    style={{
                        backgroundColor: this.props.menuColor.assetBackgroundSelectorColor,
                        color: this.props.menuColor.assetFontColor
                    }}>
                    <HashRouter>
                        <Link exact to="/" onClick={this.props.close} className="button-back" id="room_door_back"></Link>
                    </HashRouter>
                    <div className="heading align-center">
                        <div class="splash-brand">
                            <img src={`${CMSPath}${this.props.logo}`} />
                        </div>
                        {/* <p className="bold" style = {{color:"inherit",textShadow:"unset"}}>{this.props.t('door_key.header')}</p> */}
                    </div>
                </header>
                <section id="doorLocks" className="widgets padding-bottom-2 margin-0">

                    <div class="widget-header">
                        <div class="widget-header-title">{this.props.t('door_key.header')}</div>
                    </div>

                    <div className="widgets">
                        <div className="row">
                            <div className="col">
                                <div className={`unlock-container door-${this.props.doorUnlocked ? "unlocked" : "locked"}`}>

                                    <div class="unlock-container">
                                        <p>{this.props.t('door_key.your_room_number')}</p>
                                        <h1 class="align-center">{this.state.room}</h1>
                                        <div class="unlock-button-container">
                                            <div class="unlock-button-l0">
                                                <div onClick={this.props.doorUnlocked ? null : this.props.handleActivateDoorKeyFileHanlder} class="unlock-button-l1">
                                                    <div class="unlock-button-l2">
                                                        <div class="unlock-button-l3">
                                                            <a class="unlock-button-main">{this.props.doorUnlocked ? this.props.t('door_key.activated') : this.props.t('door_key.header_text3')}</a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <p class="heading bottom">
                                            <img src={"doorKeyGuide_images/img_door_unlock.png"} />
                                            {this.props.t('door_key.unlock_text')}
                                        </p>
                                    </div>
                                    <div class="renew-door-key-button" onClick={this.renewDoorKey}>
                                        <div class="text">
                                            <div class="label">
                                                <div class="label2">{this.props.t('door_key.renew_door_key_button_text')}</div>
                                            </div>
                                            <div class="border"></div>
                                        </div>
                                    </div>

                                    {/* older HTML */}
                                    {/* {(this.state.doorKeyOpened == "null") ? <h1 className="align-center">{this.state.room}</h1> : <br/>}
                                    <p className="heading" style = {{marginBottom:"2rem", marginTop:"3rem"}}>{this.props.doorUnlocked ? this.props.t('door_key.header_text1') :  this.props.t('door_key.header_text2')}</p>
                                    <div id="unlockDiv" className="unlock">
                                        <h2>
                                            <strong id="slider-unlock" className={`slider-button ${this.props.doorUnlocked ? "active" : ""}`} 
                                            style = {{
                                                backgroundColor:this.props.menuColor.assetBackgroundSelectorColor,
                                                // left: this.state.sliderLeft + "px",
                                                transform:`translateX(${this.props.sliderLeft}px)`
                                            }}></strong>
                                            <div className="door-icons">
                                                {!this.props.doorUnlocked && <span className="icon-lock"></span>}
                                                <span className="icon-unlock"></span>
                                            </div>
                                            <span className={`unlock-text`}>{this.props.doorUnlocked ? t('door_key.activated') : t('door_key.activate')}</span>
                                        </h2>
                                    </div>
                                    <p class="heading bottom" style = {{marginTop:"2rem"}}>
                                        {this.props.t('door_key.unlock_text')}
                                        <img src={doorUnlockSVG} />
                                    </p> */}
                                    {/* <p className="heading" style = {{marginTop:"2rem"}}>Unlock the door by "tapping" the phone on the door lock</p> */}
                                    {/* <div className="subheading">
                                        <span className="icon-lock"></span>
                                        <span className="icon-unlock"></span>
                                        <p>{this.props.doorUnlocked ? "Door unlocked" : "Door locked"}</p>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="doorkey" onClick={this.props.close}>
                        <HashRouter>
                            <Link exact to="/" className="tile-container"
                                style={{
                                    backgroundColor: this.props.menuColor.assetBackgroundSelectorColor,
                                    color: "#fff"
                                }}>
                                <i className="fas fa-times" ></i>
                            </Link>
                        </HashRouter>
                    </div>
                </section>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        menuColor: state.store.home.MenuColor,
        showDoorKeyPopup: state.store2.showDoorKeyPopup,
        guestDetail: state.store.home.guestDetails,
        reservationNo: state.store.reservationNo,
        runNativeCalls: state.store.doorKey.runNativeCalls,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        CheckedInGuest: state.store.CheckedInGuest,
        logo: state.store.home.currentDuration.brandingInfo ?
            state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl : "",
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        currentWidgets: state.store.sideNavBar.currentWidget,
        currentHomePage: state.store2.currentHomePage,
    }
}

export default connect(mapStateToProps, {
    currentWidget,
    setShowDoorKeyPopup,
    setDoorKeyNotificaionPage,
    popupOpenClose,
    setDeviceLoginPage,
    setDoorKeyValidationPopUp,
    SetCallNativeMethods,
    setRegPage,
    setShowRoomDoor,
    setGoHome,
    setQRScannerPage,
    sendAnalytics,
    getServerTime,
    setShowCustomPopup,
    setCallKeyclick
})(withTranslation('translations')(DoorKeySlider));